<template>
  <v-card flat class="rmr-table-shell mid-table-shell">
    <rmr-table-header
      heading-class="mid-table-shell__heading"
      controls-class="mid-table-shell__controls"
    >
      <template #heading>
        <div class="mid-table-shell__title-row">
          <div class="rmr-table-shell__title">Vue d’ensemble des métriques</div>
          <span class="mid-table-shell__count-badge">{{ items.length }}</span>
        </div>
      </template>
      <template #controls>
        <div class="rmr-table-shell__filter-item rmr-table-shell__search mid-table-shell__search">
          <label class="rmr-table-shell__filter-label">Recherche</label>
          <rmr-text-field
            :value="filterBrand"
            append-icon="mdi-magnify"
            label="Rechercher une marque"
            single-line
            @input="$emit('update:filter-brand', $event)"
          />
        </div>
        <rmr-action-button
          label="Actualiser"
          :icon="refreshIcon"
          variant="primary"
          :loading="loading"
          :spin-icon="loading"
          @click="$emit('refresh')"
        />
      </template>
    </rmr-table-header>

    <v-card-text class="rmr-table-shell__body">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        dense
        class="rmr-data-table mid-table"
      >
        <template slot="item.brand_name" slot-scope="{ item }">
          <span class="mid-table__brand-name">{{ item.brand_name }}</span>
        </template>

        <template
          v-for="metric in metrics"
          v-slot:[`item.${metric.importedField}`]="{ item }"
        >
          <metric-cell
            :key="metric.key"
            :imported-value="getImportedValue(item, metric.importedField)"
            :override-value="getOverrideValue(item, metric.overrideField)"
            :month-label="metric.monthField ? getImportedValue(item, metric.monthField) : ''"
            :format-number="formatNumber"
            :format-metric-display="formatMetricDisplay"
          />
        </template>

        <template slot="item.actions" slot-scope="{ item }">
          <div class="rmr-data-table__actions mid-table__actions">
            <rmr-icon-button
              :icon="editIcon"
              variant="edit"
              @click="$emit('edit-overrides', item)"
            />
          </div>
        </template>

        <template v-slot:no-data>
          <div class="rmr-data-table__state">
            <v-icon color="#94A3B8" size="32" class="mb-2">{{ databaseIcon }}</v-icon>
            <div class="rmr-data-table__state-title">
              {{ hasActiveFilters ? "Aucun résultat" : "Aucune donnée disponible" }}
            </div>
            <div class="rmr-data-table__state-text">
              {{
                hasActiveFilters
                  ? "Aucune marque ne correspond à la recherche. Modifiez le terme recherché."
                  : "Importez des fichiers Excel et lancez le traitement pour générer les données."
              }}
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import MetricCell from "@/components/marketing/imported-data/MetricCell.vue";
import RmrActionButton from "@/components/ui/actions/RmrActionButton.vue";
import RmrIconButton from "@/components/ui/actions/RmrIconButton.vue";
import RmrTextField from "@/components/ui/forms/RmrTextField.vue";
import RmrTableHeader from "@/components/ui/layout/RmrTableHeader.vue";

export default {
  name: "ImportedDataTableCard",
  components: {
    MetricCell,
    RmrActionButton,
    RmrIconButton,
    RmrTextField,
    RmrTableHeader,
  },
  props: {
    headers: {
      type: Array,
      default: function() {
        return [];
      },
    },
    items: {
      type: Array,
      default: function() {
        return [];
      },
    },
    metrics: {
      type: Array,
      default: function() {
        return [];
      },
    },
    filterBrand: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    formatNumber: {
      type: Function,
      required: true,
    },
    formatMetricDisplay: {
      type: Function,
      required: true,
    },
    getImportedValue: {
      type: Function,
      required: true,
    },
    getOverrideValue: {
      type: Function,
      required: true,
    },
    refreshIcon: {
      type: String,
      default: "",
    },
    editIcon: {
      type: String,
      default: "",
    },
    databaseIcon: {
      type: String,
      default: "",
    },
  },
  emits: [
    "update:filter-brand",
    "refresh",
    "edit-overrides",
  ],
  computed: {
    hasActiveFilters() {
      return Boolean((this.filterBrand || "").trim());
    },
  },
};
</script>

<style scoped>
.mid-table-shell__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mid-table-shell__count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-weight: 800;
  font-size: 0.9rem;
}

.mid-table__brand-name {
  display: inline-block;
  white-space: normal;
  word-break: break-word;
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
}

.mid-table :deep(.v-data-table__wrapper table) {
  border-collapse: separate;
  border-spacing: 0;
}

.mid-table :deep(tbody tr:hover) {
  background: rgba(255, 247, 237, 0.75);
}

.mid-table__actions {
  justify-content: center;
}

@media (max-width: 960px) {
  .mid-table-shell__search {
    min-width: 100%;
  }
}
</style>
